module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_2.cb73b06f.png";